var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container-m" },
    [
      _c(
        "h1",
        {
          staticClass: "display-1 text--darken-2",
          staticStyle: { "text-align": "center" },
          attrs: { id: "override-font-family" }
        },
        [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "subtitle text--darken-1",
          staticStyle: { "text-align": "center", "margin-top": "24px" }
        },
        [_vm._v("\n    " + _vm._s(_vm.subTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _c("login-form", {
        on: {
          loginSuccess: function($event) {
            return _vm.loginSuccess($event)
          },
          loginSuccessCallCenter: function($event) {
            return _vm.loginSuccessCallCenter($event)
          },
          loginError: function($event) {
            return _vm.showError($event)
          }
        }
      }),
      _vm._v(" "),
      _c("message-special-situation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }